'use client';

import { type FC } from 'react';

import { RosterLevelEnum } from '@wwe-portal/entities/roster.type';
import { levelEnumToLabel } from '@wwe-portal/utils/roster/level';
import { Select } from '@wwe-portal/ui/components/select';

export interface SelectItemProps {
  id: string;
  title: string;
  iconUrl?: string;
}

export interface RosterStarColorSelectProps {
  value: RosterLevelEnum;
  onChange: (value: RosterLevelEnum) => void;
}

const starColorItems = [
  RosterLevelEnum.G,
  RosterLevelEnum.S,
  RosterLevelEnum.B,
];

export const RosterStarColorSelect: FC<RosterStarColorSelectProps> = ({
  value,
  onChange,
}) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={starColorItems}
      renderItem={(item) => (
        <span className="font-semibold uppercase italic">
          {levelEnumToLabel[item]}
        </span>
      )}
      getKey={(item) => item}
      noOption={<span>Select stars color</span>}
    />
  );
};
